import { Editable, EditableInput, EditablePreview, Flex, HStack, IconButton, Text, VStack, } from "@chakra-ui/react";
import React, { useContext } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { FiAlertOctagon, FiMoreVertical } from "react-icons/fi";
import { MdOutlineDragHandle } from "react-icons/md";
import { reorder } from "../helpers";
import { LayoutItemMoreMenu } from "../LayoutItem/LayoutItemMoreMenu";
import { useServices } from "../hooks/useServices";
import { StudioContext } from "../studioContext";
const LayoutListItem = ({ layoutService, layoutItem, index, widgets, }) => {
    const widget = widgets.find((w) => w.name === layoutItem.widgetName);
    return (React.createElement(HStack, { key: layoutItem.id, flexGrow: 1, overflow: "hidden" },
        (widget === null || widget === void 0 ? void 0 : widget.icon) || React.createElement(FiAlertOctagon, null),
        React.createElement(Editable, { defaultValue: layoutItem.name || `Playlist ${index + 1}`, isTruncated: true, onSubmit: (value) => {
                layoutService.updateLayoutItem({ ...layoutItem, name: value });
            } },
            React.createElement(EditablePreview, null),
            React.createElement(EditableInput, null))));
};
export const LayoutItemList = () => {
    const { layoutService } = useServices();
    const { isLocked, widgets, layoutItems, selectedLayoutItemId } = useContext(StudioContext);
    return (React.createElement(DragDropContext, { onDragEnd: (result) => {
            if (!result.destination) {
                return;
            }
            reorder(layoutItems, result.source.index, result.destination.index).forEach((layoutItem, index) => {
                const z = layoutItems.length - 1 - index;
                if (layoutItem.z !== z) {
                    layoutService.updateLayoutItem({
                        ...layoutItem,
                        z: z,
                    });
                }
            });
        } },
        React.createElement(Droppable, { droppableId: "droppable", isDropDisabled: isLocked }, (provided, snapshot) => (React.createElement(VStack, { spacing: "0px", align: "stretch", width: "100%", height: "100%", ...provided.droppableProps, ref: provided.innerRef, "data-testid": "lateral-menu-zones-list-test-id" },
            layoutItems
                .sort((a, b) => b.z - a.z)
                .map((layoutItem, index) => (React.createElement(Draggable, { key: layoutItem.id + "side-list", draggableId: layoutItem.id, index: index, isDragDisabled: isLocked }, (provided, snapshot) => (React.createElement(Flex, { shadow: snapshot.isDragging ? "lg" : "none", ref: provided.innerRef, ...provided.draggableProps, width: "100%", borderRadius: "6px", padding: "8px", backgroundColor: selectedLayoutItemId === layoutItem.id
                    ? "orange.100"
                    : "unset", cursor: "pointer", _hover: {
                    backgroundColor: "gray.100",
                }, onClick: () => {
                    layoutService.selectLayoutItem(layoutItem.id);
                } },
                React.createElement(IconButton, { "aria-label": "drag", variant: "ghost", icon: React.createElement(MdOutlineDragHandle, null), ...provided.dragHandleProps }),
                React.createElement(LayoutListItem, { layoutService: layoutService, layoutItem: layoutItem, index: index, widgets: widgets }),
                React.createElement(LayoutItemMoreMenu, { layoutItem: layoutItem, "aria-label": "More", icon: React.createElement(FiMoreVertical, null), variant: "ghost" })))))),
            provided.placeholder,
            layoutItems.length === 0 ? (React.createElement(Text, { textAlign: "center" }, "Aucun \u00E9l\u00E9ment pour l'instant, ajoutez en depuis le menu \u00E0 gauche")) : (React.createElement(React.Fragment, null)))))));
};
